import { colorMap, colorOpacity, customTheme } from 'theme';

import { defaultSelectStyles } from 'components/DataEntry';

export const selectEnvironmentOrAccountStyles = {
  menu: provided => ({
    ...provided,
    width: 'max-content',
    minWidth: '100%',
    right: 0,
  }),
  control: (styles, props) => ({
    ...defaultSelectStyles().control(styles, props),
    color: '#fff',
    borderColor: customTheme.colors.primary,
    backgroundColor: customTheme.colors.topNavSearchBg,
    borderRadius: '5px',
  }),
  container: (styles, props) => ({
    ...defaultSelectStyles('32px').container(styles, props),
    width: '220px',
    height: '30px',
  }),
  valueContainer: (styles, props) => ({
    ...defaultSelectStyles().valueContainer(styles, props),
    color: 'white',
    borderRadius: '5px',
  }),
  indicatorsContainer: (styles, props) => ({
    ...defaultSelectStyles().indicatorsContainer(styles),
    borderRadius: '5px',
  }),
  singleValue: (styles, props) => ({
    ...styles,
    color: 'white',
  }),
  placeholder: provided => ({
    ...provided,
    color: 'white',
    opacity: 1,
  }),
  option: (provided, { isSelected, isDisabled, isMulti }) => {
    return {
      ...provided,
      '&:active': {
        backgroundColor: colorOpacity(customTheme.colors.primary, 0.2),
      },

      '&:hover': {
        //backgroundColor: colorOpacity(customTheme.colors.primary, 0.2),
        backgroundColor: isSelected
          ? colorOpacity(customTheme.colors.primary, 0.2)
          : 'hover',
        //color: isSelected ? '#fff' : '#000',
      },

      color: isSelected ? customTheme.colors.primary : '#000',
      cursor: isDisabled ? 'not-allowed' : 'pointer',
      backgroundColor:
        isSelected && !isMulti
          ? colorOpacity(customTheme.colors.primary, 0.2)
          : '#fff',
      marginBottom: '1px',
      borderRadius: 6,
    };
  },
};
